import React from "react";

import Submit from "../HandleSubmit";

import styles from "./main-timer-display.module.scss";

const debounce = (fn, delay) => {
    let timer;
    let modification = 0;
    return (...args) => {
        const {tickerAddSeconds} = args[0];
        modification += tickerAddSeconds;
        clearTimeout(timer);
        timer =  setTimeout(() =>{
            const newArgs = {
                ...args[0],
                tickerAddSeconds: modification
            }
            fn(newArgs);
            modification = 0;
        }, delay)
    }
}

let submitTimeModification = (options) => {
    const {matchId, matchData, tickerAddSeconds, setMatchData} = options;
    const update = {
        tickerTimer: true,
        dhbMatchTimers: {
            tickerAddSeconds
        }
    }
    Submit(matchId, matchData, update, setMatchData);
}

submitTimeModification = debounce(submitTimeModification, 2000);

const IncreaseDecreaseTimerButton = ({
    modifier,
    timerSecondsSelected,
    quarterParams,
    setTimersPerQuarter,
    matchId,
    matchData,
    setMatchData
  }) => {
    const modifierLabel = modifier === '+' ? 'Shorten' : 'Extend';
    return (
      <button
        className={styles['left-timer__adjust-button']}
        onClick={() => {
          const tickerAddSeconds = Number(modifier + timerSecondsSelected);
          submitTimeModification({tickerAddSeconds, matchId, matchData, setMatchData});
          setTimersPerQuarter((details) => {
            if (modifier === "-") {
              const totalTimeCheck = eval(
                  details[quarterParams?.id]["timePlayed"] +
                  modifier +
                  timerSecondsSelected
              );
              if (totalTimeCheck <= 0) {
                return {
                  ...details,
                  [quarterParams?.id]: {
                    ...details[quarterParams?.id],
                      timePlayed: 0
                  },
                };
              }
            }
            if(modifier === '+') {
                const timerCheck = eval(
                    details[quarterParams?.id]["timeLeft"] +
                    '-' +
                    timerSecondsSelected
                );
                if (timerCheck <= 0) {
                    return {
                        ...details,
                        [quarterParams?.id]: {
                            ...details[quarterParams?.id],
                            timeLeft: 0
                        },
                    };
                }
            }
            const newModifier = modifier === '+' ? '-' : '+';
            return {
              ...details,
              [quarterParams?.id]: {
                ...details[quarterParams?.id],
                timeLeft: eval(
                  details[quarterParams?.id]["timeLeft"] +
                    newModifier +
                    timerSecondsSelected
                ),
                timePlayed: eval(
                    details[quarterParams?.id]["timePlayed"] +
                    modifier +
                    timerSecondsSelected
                )
              },
            };
          });
        }}
      >
        {modifierLabel} {timerSecondsSelected} Sek
      </button>
    );
};

export default IncreaseDecreaseTimerButton;